import { useQueries, useQuery } from '@tanstack/react-query'
import http from '../../utils/Http/Http'
import { useEffect, useMemo, useState } from 'react'

export const getAgentById = async (id: string) => {
	const url = `/agents/${id}`
	const res = await http({
		url,
		method: 'get',
	})

	return res.data
}

export function useFetchAgent(id: string, enabled: boolean = true, refetchInterval: number | false = false) {
	const {
		data: agent,
		isFetching: fetchingAgent,
		refetch: refetchAgent,
	} = useQuery({
		queryKey: [`agent_${id}`],
		queryFn: () => getAgentById(id),
		enabled: enabled && !!id,
		refetchInterval,
	})

	return { agent, fetchingAgent, refetchAgent }
}

export function useFetchAgentsByID(ids: string[]) {
	const [agents, setAgents] = useState<any[]>([])
	const agentQueries = useQueries({
		queries: ids.map((id) => ({
			queryKey: [`agent_${id}`],
			queryFn: () => getAgentById(id),
		})),
	})

	useEffect(() => {
		if (agentQueries.every((agentQuery) => !agentQuery.isFetching)) {
			const results = agentQueries.map((agentQuery) => agentQuery.data)
			setAgents(results)
		}
	}, [agentQueries])

	const loading = useMemo(() => agentQueries.some((agentQuery) => agentQuery.isFetching), [agentQueries])

	return { agentsByID: agents, loading: loading }
}
